import "./styles.scss";
import { Constants } from "appConstants";

export default function StatusCard({ status }: any) {
	const statusValue = status === 1 ? "active" : "inactive";

	return (
		<div className={`status-card ${statusValue}`}>
			{Constants.strings.general.status[statusValue]}
		</div>
	);
}
